import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Paragraph = superstyled({
  tag: Text,
  name: 'messageFormatValues',
  slot: 'Paragraph',
  styles: {
    margin: 0,
  },
});
